import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import { Redirect } from "react-router-dom";
import Input from "@material-ui/core/Input";
import InputLabel from "@material-ui/core/InputLabel";
import {
  hideNotification,
  logIn,
  showSpinner,
  hideSpinner,
} from "../redux/actions";
import Button from "@material-ui/core/Button";
import CssBaseline from "@material-ui/core/CssBaseline";
import FormControl from "@material-ui/core/FormControl";
import { Field } from "react-final-form-html5-validation";
import { Form } from "react-final-form";
import Paper from "@material-ui/core/Paper";
import Typography from "@material-ui/core/Typography";
import { makeStyles } from "@material-ui/core/styles";
import { img } from "../config";
import HelpModal from "./HelpModal";
import api from "../api";
import zxc from "zxcvbn";
import Modal from "@material-ui/core/Modal";
import Cookies from "universal-cookie";
const cookies = new Cookies();

const useStyles = makeStyles((theme) => ({
  main: {
    width: "auto",
    display: "block",
    marginLeft: theme.spacing(3),
    marginRight: theme.spacing(3),
    [theme.breakpoints.up(400 + theme.spacing(6))]: {
      width: 400,
      marginLeft: "auto",
      marginRight: "auto",
    },
  },
  paper: {
    marginTop: theme.spacing(8),
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    padding: `${theme.spacing(2)}px ${theme.spacing(3)}px ${theme.spacing(
      3
    )}px`,
  },
  avatar: {
    margin: theme.spacing(1),
    width: 60,
    height: 60,
  },
  form: {
    width: "100%",
    marginTop: theme.spacing(1),
  },
  submit: {
    marginTop: theme.spacing(4),
    width: "100%",
    padding: "0.75em",
  },
  error: {
    color: "red",
    marginBottom: 0,
    textAlign: "center",
  },
  passScore0: {
    margin: 0,
    color: "red",
    fontWeight: 500,
  },
  passScore1: {
    margin: 0,
    color: "#ff7200",
    fontWeight: 500,
  },
  passScore2: {
    margin: 0,
    color: "#0098c2",
    fontWeight: 500,
  },
  passScore3: {
    margin: 0,
    color: "#3f51b5",
    fontWeight: 500,
  },
  passScore4: {
    margin: 0,
    color: "green",
    fontWeight: 500,
  },
  info: {
    marginBottom: 0,
    textAlign: "center",
  },
  install: {
    width: "100%",
    textAlign: "center",
    "& button": {
      width: "100%",
      padding: "1em",
    },
  },
  action: {
    marginTop: "0.5em",
  },
  warning: {
    textAlign: "center",
    "& h3": {
      color: theme.palette.error.main,
    },
    "& img": {
      width: 40,
      height: 40,
      verticalAlign: "middle",
      margin: 4,
    },
    "& a": {
      display: "flex",
      position: "relative",
      justifyContent: "space-between",
      alignItems: "center",
      lineHeight: 1,
      width: 218,
      height: 48,
      maxWidth: "100%",
      textDecoration: "none",
      margin: "0.5em auto",
      border: "1px solid rgba(0, 0, 0, 0.3)",
      borderRadius: "0.5em",
      boxShadow: "1px 1px 5px rgba(0, 0, 0, 0.3)",
      fontWeight: 500,
      color: "#666",
      transition: "all 0.3s",
      background:
        "linear-gradient(to bottom, rgba(255,255,255,1) 0%,rgba(241,241,241,1) 50%,rgba(225,225,225,1) 51%,rgba(246,246,246,1) 100%)",
      "&:hover": {
        transform: "scale(1.1)",
      },
      "& span": {
        width: 170,
        textAlign: "center",
      },
    },
  },
  checkbox: {
    marginBottom: "1em",
  },
  forgotPass: {
    textAlign: "right",
    fontSize: 12,
    color: theme.palette.primary.main,
    cursor: "pointer",
    "&:hover": {
      textDecoration: "underline",
    },
  },
  remindInfo: {
    textAlign: "center",
  },
  oldPlatform: {
    textAlign: "center",
    marginTop: 20,
    "& a": {
      textDecoration: "none",
      color: "#333",
      display: "inline-block",
      padding: "0 10px",
    },
  },
  infoModal: {
    maxWidth: 400,
    margin: "0 auto",
    display: "flex",
    alignItems: "center",
  },
  infoModalInner: {
    backgroundColor: theme.palette.background.paper,
    padding: "10px 20px",
    boxShadow: theme.shadows[5],
  },
}));

function SignIn(props) {
  const classes = useStyles();
  const [showInstall, setShowInstall] = useState(false);
  const [view, setView] = useState("login");
  const [token, setToken] = useState(null);
  const [errorMsg, setErrorMsg] = useState(false);
  const [infoMsg, setInfoMsg] = useState(false);
  const [pass, setPass] = useState("");
  const [passScore, setPassScore] = useState(0);
  const [mainHelp, setMainHelp] = useState(false);
  const [deferredPrompt, setDeferredPrompt] = useState(null);
  const [authorized, setAuthorized] = useState(false);
  const [modalOpen, setModalOpen] = React.useState(false);

  useEffect(() => {
    const token = new URLSearchParams(window.location.search).get("token");
    if (token) {
      setView("change-pass");
      setToken(token);
    }
    window.addEventListener("beforeinstallprompt", handleBeforeInstal);
    if (!cookies.get("new-app-info")) setModalOpen(true);
    return () => {
      window.removeEventListener("beforeinstallprompt", handleBeforeInstal);
    };
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    if (props.auth && props.auth.loggedIn) {
      setAuthorized(true);
    }
    // eslint-disable-next-line
  }, [props.auth]);

  const handleBeforeInstal = (e) => {
    e.preventDefault();
    setDeferredPrompt(e);
    setShowInstall(true);
  };

  const onSubmit = ({ email, password }) => {
    props.logIn(email, password);
  };

  const onPassReset = (data) => {
    props.auth.clearError();

    const options = {
      method: "post",
      data: data,
      url: "/password-recovery",
      withCredentials: false,
    };

    props.showSpinner();

    api(options)
      .then((response) => {
        setInfoMsg(
          "Link do zmiany hasła został wysłany na Twój adres email. Może to potrwać kilka minut. Jeśli email nie dotrze sprawdź folder spam."
        );
        setView("info");
        setErrorMsg(false);
      })
      .catch((e) => {
        setInfoMsg(false);
        setView("info");
        setErrorMsg(
          "Błąd sieci. Upewnij się, że masz połączenie internetowe i spróbuj jeszcze raz."
        );
      })
      .finally((ev) => {
        props.hideSpinner();
      });
  };

  const onPassChange = ({ email, password }) => {
    const data = { email, newPassword: pass, token };

    const options = {
      method: "post",
      data: data,
      url: "/password-recovery/change",
      withCredentials: false,
    };

    props.showSpinner();

    api(options)
      .then((response) => {
        setInfoMsg("Hasło pomyślnie zmienione");
        setView("info");
        setErrorMsg(false);
      })
      .catch((e) => {
        let message;
        if (e.message.search("400") >= 0) {
          message =
            "Token wygasł. Proszę ponownie użyć opcji odzywkania hasła.";
        } else {
          message =
            "Błąd sieci. Sprawdź połączenie internetowe i odśwież stronę.";
        }
        setErrorMsg(message);
        setView("info");
        setInfoMsg(false);
      })
      .finally((ev) => {
        props.hideSpinner();
      });
  };

  const installApp = () => {
    setShowInstall(false);
    deferredPrompt.prompt();
  };

  const mainHelpToggle = () => {
    setMainHelp(!mainHelp);
  };

  const handleModalClose = () => {
    setModalOpen(false);
    cookies.set("new-app-info", "true", { path: "/", maxAge: 100000000 });
  };

  const renderLogin = () => {
    const isPwa = props.auth.browser.pwa;

    return (
      <>
        <Paper className={classes.paper}>
          <div className={classes.avatar}>
            <img src={img("szybki-angielski-icon-1.png")} alt="" />
          </div>
          <Typography component="h1" variant="h5">
            Logowanie
          </Typography>
          {showInstall && (
            <div className={classes.install}>
              <p>
                Aby mieć dostęp do wszystkich możliwości platformy, zainstaluj
                aplikację
              </p>
              <Button
                variant="contained"
                color="secondary"
                onClick={installApp}
              >
                Instaluj
              </Button>
            </div>
          )}
          {props.auth.error && (
            <p className={classes.error}>{props.auth.error}</p>
          )}
          <Form
            onSubmit={onSubmit}
            render={({ handleSubmit, pristine, invalid }) => (
              <form onSubmit={handleSubmit}>
                <Field name="email">
                  {({ input, meta }) => (
                    <FormControl margin="normal" required fullWidth>
                      <InputLabel htmlFor="email">
                        Nazwa użytkownika lub e-mail
                      </InputLabel>
                      <Input
                        {...input}
                        autoComplete="on"
                        autoCorrect="off"
                        autoCapitalize="none"
                        type="text"
                      />
                    </FormControl>
                  )}
                </Field>
                <Field name="password">
                  {({ input, meta }) => (
                    // <FormControl margin="normal" required fullWidth>
                    <FormControl margin="normal" fullWidth>
                      <InputLabel htmlFor="password">Hasło</InputLabel>
                      <Input
                        {...input}
                        autoComplete="current-password"
                        type="password"
                      />
                    </FormControl>
                  )}
                </Field>
                <Button
                  variant="contained"
                  type="submit"
                  color="primary"
                  className={classes.submit}
                >
                  {/* <Button variant="contained" type="submit" color="primary" className={classes.submit} disabled={pristine || invalid}> */}
                  Zaloguj
                </Button>
                <p
                  className={classes.forgotPass}
                  onClick={() => setView("remind-pass")}
                >
                  przypomnij hasło
                </p>
              </form>
            )}
          />
          {!isPwa && (
            <Button size="small" color="secondary" onClick={mainHelpToggle}>
              Instrukcja instalacji
            </Button>
          )}
        </Paper>
        <div className={classes.oldPlatform}>
          <Button>
            <a href="https://platforma.szybkiangielski.pl/palio/html.run?_Instance=icr">
              Wejście do poprzedniej wersji platformy -> TUTAJ
            </a>
          </Button>
        </div>
        <Modal
          open={modalOpen}
          onClose={handleModalClose}
          className={classes.infoModal}
        >
          <div className={classes.infoModalInner}>
            <h3>Witaj na platformie!</h3>
            <p>
              po zalogowaniu zobaczysz tymczasową, bardziej funkcjonalną i
              przyjazną wersję aplikacji, którą właśnie wdrożyliśmy. Posiada ona
              pełny zakres funkcjonalności dotychczasowej platformy.
            </p>
            <p>Aby się zalogować, wpisz swój dotychczasowy login i hasło.</p>
            <p>
              <strong>Powodzenia!</strong>
            </p>
            <p style={{ textAlign: "right" }}>
              <Button onClick={handleModalClose}>Zamknij</Button>
            </p>
          </div>
        </Modal>
        {mainHelp && (
          <HelpModal
            close={mainHelpToggle}
            options={{ name: "main", option: "tabs" }}
          />
        )}
      </>
    );
  };

  const renderRemindPass = () => {
    return (
      <Paper className={classes.paper}>
        <div className={classes.avatar}>
          <img src={img("szybki-angielski-icon-1.png")} alt="" />
        </div>
        <Typography component="h1" variant="h5">
          Przypomnij hasło
        </Typography>
        <p className={classes.remindInfo}>
          Nie pamiętasz hasła? Podaj swój adres e-mail, wyślemy na niego
          informację jak odzyskać hasło.
        </p>
        <Form
          onSubmit={onPassReset}
          render={({ handleSubmit, pristine, invalid }) => (
            <form onSubmit={handleSubmit}>
              <Field name="email">
                {({ input, meta }) => (
                  <FormControl margin="normal" required fullWidth>
                    <InputLabel htmlFor="email">E-mail</InputLabel>
                    <Input
                      {...input}
                      autoComplete="on"
                      autoCorrect="off"
                      autoCapitalize="off"
                      type="email"
                    />
                  </FormControl>
                )}
              </Field>
              <Button
                variant="contained"
                type="submit"
                color="primary"
                className={classes.submit}
              >
                Wyślij
              </Button>
            </form>
          )}
        />
      </Paper>
    );
  };

  const renderInfo = () => {
    return (
      <Paper className={classes.paper}>
        <div className={classes.avatar}>
          <img src={img("szybki-angielski-icon-1.png")} alt="" />
        </div>
        {errorMsg && <p className={classes.error}>{errorMsg}</p>}
        {infoMsg && <p className={classes.info}>{infoMsg}</p>}
        <p className={classes.forgotPass} onClick={() => setView("login")}>
          Powrót do strony logowania
        </p>
      </Paper>
    );
  };

  const onPassInputChange = (ev) => {
    const pass = ev.target.value;
    const passScore = zxc(pass).score;
    setPass(pass);
    setPassScore(passScore);
  };

  const renderChangePass = () => {
    const passLen = pass.length;
    const passScore = passScore;

    return (
      <Paper className={classes.paper}>
        <div className={classes.avatar}>
          <img src={img("szybki-angielski-icon-1.png")} alt="" />
        </div>
        <Typography component="h1" variant="h5">
          Zmień hasło
        </Typography>
        <p className={classes.remindInfo}>
          W celu zmiany hasła proszę podać e-mail użyty przy rejestracji i nowe
          hasło.
        </p>
        <Form
          onSubmit={onPassChange}
          render={({ handleSubmit, pristine, invalid }) => (
            <form onSubmit={handleSubmit}>
              <Field name="email">
                {({ input, meta }) => (
                  <FormControl margin="normal" required fullWidth>
                    <InputLabel htmlFor="email">E-mail</InputLabel>
                    <Input
                      {...input}
                      autoComplete="on"
                      autoCorrect="off"
                      autoCapitalize="off"
                      type="email"
                    />
                  </FormControl>
                )}
              </Field>
              <Field name="password">
                {({ input, meta }) => (
                  <FormControl margin="normal" fullWidth>
                    <InputLabel htmlFor="password">Hasło</InputLabel>
                    <Input
                      {...input}
                      autoComplete="off"
                      type="password"
                      value={pass}
                      onChange={onPassInputChange}
                    />
                  </FormControl>
                )}
              </Field>
              {passLen > 0 && passScore < 1 && (
                <p className={classes.passScore0}>Hasło bardzo słabe</p>
              )}
              {passLen > 0 && passScore === 1 && (
                <p className={classes.passScore1}>Hasło niewystarczające</p>
              )}
              {passLen > 0 && passScore === 2 && (
                <p className={classes.passScore2}>Hasło słabe</p>
              )}
              {passLen > 0 && passScore === 3 && (
                <p className={classes.passScore3}>Hasło dobre</p>
              )}
              {passLen > 0 && passScore > 3 && (
                <p className={classes.passScore4}>Hasło bardzo dobre :)</p>
              )}
              <Button
                variant="contained"
                type="submit"
                color="primary"
                className={classes.submit}
                disabled={passScore < 2}
              >
                Wyślij
              </Button>
            </form>
          )}
        />
      </Paper>
    );
  };

  if (authorized) return <Redirect to="/" />;

  return (
    <main className={classes.main}>
      <CssBaseline />
      {view === "login" && renderLogin()}
      {view === "remind-pass" && renderRemindPass()}
      {view === "change-pass" && renderChangePass()}
      {view === "info" && renderInfo()}
    </main>
  );
}

function mapStateToProps(state) {
  return { auth: state.auth };
}

export default connect(mapStateToProps, {
  hideNotification,
  logIn,
  showSpinner,
  hideSpinner,
})(SignIn);
